module.exports = __webpack_public_path__ + "static/media/pan.9ea20b63.png";